module.exports = __webpack_public_path__ + "media/images/icon/icons8-Numbered List-63f8c49ab4e48ab3b2283b6f8d34ecff.png";